import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const scorecardDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getTeamLeadScoreCards: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month,applicationRoleId } = arg;

                return {
                    url: constants.EMPLOYEE_SCORECARDS_BY_ROLE,
                    params: { employeenumber, year, month ,applicationRoleId},
                };
            },
        }),
        getTeamLeadMonthlyMetricsSummary: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId, scorecardRoleId,isFromCoachingAction } = arg;
                return {
                    url: constants.MONTHLY_METRIC_SUMMARY,
                    params: { employeenumber, year, month, scorecardVersionId, scorecardRoleId,isFromCoachingAction },
                };
            },
        }),
        getTeamLeadScorecardAgents: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: constants.EMPLOYEE_TEAMLEAD_SCORECARD_AGENTS,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
            providesTags: ['Disputes'],
            // keepUnusedDataFor:0,
        }),
        getstackRankSearch: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId,ScorecardRoleId, showNonPayoutMetrics } = arg;
                return {
                    url: constants.STACK_RANK_SEARCH,
                    params: { employeenumber, year, month, scorecardVersionId,ScorecardRoleId, showNonPayoutMetrics },
                };
            },
            providesTags: ['StackRank'],
            keepUnusedDataFor: 1800, // Cache for 30 minutes (1800 seconds)
        }),
        getPieDataScoreCards: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: constants.TEAMLEAD_PIE_SCORECARDS,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
        }),
        getPieDataScoreCardsTier: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: constants.TEAMLEAD_PIE_SCORECARDS_TIER,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
        }),
        getScoreCardDisputes: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: constants.SCORECARDS_DISPUTES,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
            providesTags: ['Disputes'],
        }),
       
        getTeamLeadPayoutData: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: constants.TEAMLEAD_PAYOUT_DATA,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
            providesTags: ['TeamPayoutApprovals'],
        }),
        getTeamleadPayoutMonths: builder.query({
            query: (arg: any) => {
                const { employeenumber } = arg;
                return {
                    url: constants.TEAMLEAD_PAYOUT_MONTHS,
                    params: { employeenumber },
                };
            },
        }),
        updatePayoutApprovals: builder.mutation({
            query: (arg: any) => ({
                url: constants.UPDATE_PAYOUT_APPROVALS,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['TeamPayoutApprovals'],
        }),
    }),
});

export const {
    useGetTeamLeadScoreCardsQuery,
    useGetTeamLeadScorecardAgentsQuery,
    useGetstackRankSearchQuery,
    useGetTeamLeadMonthlyMetricsSummaryQuery,
    useGetPieDataScoreCardsQuery,
    useGetPieDataScoreCardsTierQuery,
    useGetScoreCardDisputesQuery,
    useGetTeamLeadPayoutDataQuery,
    useGetTeamleadPayoutMonthsQuery,
    useUpdatePayoutApprovalsMutation,
} = scorecardDashboardSlice;
